// Keep all in the same file for now
import hotkeys from "hotkeys-js";

import { store } from "common/store";
import { nextTick } from "common/utils";
import {
    PERSIST_SETTINGS as PERSIST_SETTINGS_ACTION,
    DEBUG_MODE,
    POLLING,
    SET_API as SET_API_ACTION,
    RUN_SENTRY_LOCALHOST as RUN_SENTRY_LOCALHOST_ACTION,
    CREATE_SSO_USERS as CREATE_SSO_USERS_ACTION,
    RESET_STATE
} from "../reducers/settings";

const reloadPage = function() {
    nextTick(() => {
        window.location.reload();
    });
};

export const supportedEnvs = {
    production: "https://api.pazien.com",
    staging: "https://api.stg1.pazien.com",
    staging2: "https://api.stg2.pazien.com",
    staging3: "https://api.stg3.pazien.com",
    development: "//api.dev1.pazien.com",
    localhost: "//localhost:8080",
    "default": "default"
};

export const PERSIST_SETTINGS = function(enable) {
    return (dispatch) => {
        dispatch(PERSIST_SETTINGS_ACTION(enable));
    };
};

export const DEBUG_LISTENERS = function() {
    hotkeys("alt+shift+command+i", (event, handler) => {
        // Prevent the default refresh event under WINDOWS system
        event.preventDefault();
        store.dispatch(DEBUG_MODE(!store.getState().settings.viewInspector));
        reloadPage();
    });

    hotkeys("alt+command+r+s", (event, handler) => {
        event.preventDefault();
        store.dispatch(RESET_STATE());
        reloadPage();
    });
    
    window.addEventListener("unhandledrejection", (e) => {
        if (store.getState().config.debug) {
            console.error(e.reason);
            // If your browser triggers a breakpoint here, you need to properly handle promise rejection
            debugger; // eslint-disable-line
        }
    });
};

export const ENABLE_DEBUG_MODE = function() {
    return (dispatch) => {
        dispatch(DEBUG_MODE(true));
        reloadPage();
    };
};

export const DISABLE_DEBUG_MODE = function() {
    return (dispatch) => {
        dispatch(DEBUG_MODE(false));
        reloadPage();
    };
};

export const ENABLE_POLLING = function() {
    return (dispatch) => {
        dispatch(POLLING(true));
    };
};

export const DISABLE_POLLING = function() {
    return (dispatch) => {
        dispatch(POLLING(false));
    };
};

export const CREATE_SSO_USERS = function(enable) {
    return (dispatch) => {
        dispatch(CREATE_SSO_USERS_ACTION(enable));
    };
};

export const RUN_SENTRY_LOCALHOST = function(enable) {
    return (dispatch) => {
        dispatch(RUN_SENTRY_LOCALHOST_ACTION(enable));
    
        reloadPage();
    };
};

export const SET_API = function(env) {
    return (dispatch) => {
        dispatch(SET_API_ACTION(env));
        reloadPage();
    };
};
